<template>
    <canvas :id="chartId"></canvas>
</template>

<script>
    //import Chart from 'chart.js';

    export default {
        name: "Chart",
        props: {
            chartId: {
                type: String,
                required: true
            },
            chartData: {
                type: Object,
                default() { return {}}
            },
        },
        methods: {
            createChart(id, data) {
                const ctx = document.getElementById(id).getContext('2d');
                // const myChart = new Chart(ctx, {
                //     type: data.type,
                //     data: data.data,
                //     options: data.options,
                // });
            }
        },
        watch: {
            chartData: {
                deep: true,
                immediate: true,
                handler(data) {
                    this.createChart(this.chartId, data);
                }
            }
        }
    }
</script>

<style scoped></style>